export default __webpack_public_path__ + "static/portfolio_gallery_10-752041b02d279c448f960bf197267d6d.jpg";